import { isEmpty, isNil } from 'lodash-es';
import type {
  AppConfigType,
  AppConfigurationType,
} from '../redux/ducks/ConfigDucks.types';
import {
  getEnvironmentVariable,
  setEnvironmentVariable,
} from '../utils/EnvironmentHelper/functions';

export const setupApp = (appConfig: AppConfigType): AppConfigurationType => {
  const selectedConfig = appConfig.configurations.filter(
    (conf) => conf.name === 'main',
  )[0];

  const devMode = import.meta.env.VITE_DEVELOPMENT || !import.meta.env.PROD;

  if (isNil(getEnvironmentVariable('REACT_APP_AUTH_API'))) {
    setEnvironmentVariable(
      'REACT_APP_AUTH_API',
      `${devMode ? 'http' : 'https'}://${!isNil(import.meta.env?.VITE_AUTH_API) && !isEmpty(import.meta.env?.VITE_AUTH_API) ? import.meta.env?.VITE_AUTH_API : selectedConfig.auth.api}`,
    );
  }

  if (isNil(getEnvironmentVariable('REACT_APP_AUTH_DOMAIN'))) {
    setEnvironmentVariable(
      'REACT_APP_AUTH_DOMAIN',
      !isNil(import.meta.env?.VITE_AUTH_DOMAIN) &&
        !isEmpty(import.meta.env?.VITE_AUTH_DOMAIN)
        ? import.meta.env?.VITE_AUTH_DOMAIN
        : selectedConfig.auth.domain,
    );
  }

  if (isNil(getEnvironmentVariable('REACT_APP_MAIN_API'))) {
    setEnvironmentVariable(
      'REACT_APP_MAIN_API',
      `${devMode ? 'http' : 'https'}://${
        !isNil(import.meta.env?.VITE_MAIN_API) &&
        !isEmpty(import.meta.env?.VITE_MAIN_API)
          ? import.meta.env?.VITE_MAIN_API
          : selectedConfig.babylon.api
      }`,
    );
  }

  if (isNil(getEnvironmentVariable('REACT_APP_CDN_API'))) {
    setEnvironmentVariable(
      'REACT_APP_CDN_API',
      `${
        !isNil(import.meta.env?.VITE_CDN_API) &&
        !isEmpty(import.meta.env?.VITE_CDN_API)
          ? import.meta.env?.VITE_CDN_API
          : selectedConfig.babylon.cdn
      }`,
    );
  }

  if (isNil(getEnvironmentVariable('REACT_APP_DOMAIN_CODE'))) {
    setEnvironmentVariable(
      'REACT_APP_DOMAIN_CODE',
      !isNil(import.meta.env?.VITE_DOMAIN_CODE) &&
        !isEmpty(import.meta.env?.VITE_DOMAIN_CODE)
        ? import.meta.env?.VITE_DOMAIN_CODE
        : selectedConfig.babylon.domain,
    );
  }

  if (
    isNil(getEnvironmentVariable('REACT_APP_UMAMI_WEBSITE')) &&
    !isNil(selectedConfig.babylon?.umami_website_id)
  ) {
    setEnvironmentVariable(
      'REACT_APP_UMAMI_WEBSITE',
      !isNil(import.meta.env?.VITE_UMAMI_WEBSITE) &&
        !isEmpty(import.meta.env?.VITE_UMAMI_WEBSITE)
        ? import.meta.env?.VITE_UMAMI_WEBSITE
        : selectedConfig.babylon.umami_website_id,
    );
  }

  if (
    isNil(getEnvironmentVariable('REACT_APP_UMAMI_DOMAIN')) &&
    !isNil(selectedConfig.babylon?.umami_domain)
  ) {
    setEnvironmentVariable(
      'REACT_APP_UMAMI_DOMAIN',
      !isNil(import.meta.env?.VITE_UMAMI_DOMAIN) &&
        !isEmpty(import.meta.env?.VITE_UMAMI_DOMAIN)
        ? import.meta.env?.VITE_UMAMI_DOMAIN
        : selectedConfig.babylon.umami_domain,
    );
  }

  return selectedConfig;
};
